import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "w-full md:p-[40px] p-[20px] px-[0px]" }
const _hoisted_2 = { class: "w-full px-[20px] border-l-[5px] border-blue-600 text-left" }
const _hoisted_3 = { class: "text-2xl font-bold" }
const _hoisted_4 = { class: "my-[20px] md:my-[40px] w-full h-auto md:min-h-[400px] px-[10px] md:flex justify-between relative" }
const _hoisted_5 = { class: "md:w-5/12 relative" }
const _hoisted_6 = ["src"]
const _hoisted_7 = { class: "p-[10px] md:p-[50px] md:py-[10px] md:w-7/12 text-left relative" }
const _hoisted_8 = { class: "capitalize text-justify" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_10 = { class: "w-full relative bg-gray-300 my-[20px] p-[20px] rounded-[5px]" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "capitalize" }
const _hoisted_13 = { class: "list-disc mx-[20px]" }
const _hoisted_14 = { class: "list-disc mx-[20px]" }
const _hoisted_15 = { class: "list-disc mx-[20px]" }
const _hoisted_16 = { class: "list-disc mx-[20px]" }
const _hoisted_17 = { class: "list-disc mx-[20px]" }

import { ref, onMounted } from 'vue';
  import { useRouter } from 'vue-router';
  
export default /*#__PURE__*/_defineComponent({
  __name: 'One_service',
  props: {
    services: {}
  },
  setup(__props: any) {

  const router = useRouter()
  
  function goTocontactPage() {
      router.push('/contacts')
  }
    const props = __props;


return (_ctx: any,_cache: any) => {
  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.services, (service) => {
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("h1", _hoisted_3, _toDisplayString(_ctx.$t(service.name)), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("img", {
            src: service.image,
            alt: "",
            class: "relative top-0 w-auto"
          }, null, 8, _hoisted_6)
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("p", _hoisted_8, [
            _createTextVNode(_toDisplayString(_ctx.$t(service.description)) + " ", 1),
            _hoisted_9
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h1", _hoisted_11, _toDisplayString(_ctx.$t('key')), 1),
            _createElementVNode("ul", _hoisted_12, [
              _createElementVNode("li", _hoisted_13, _toDisplayString(_ctx.$t(service.key[0])), 1),
              _createElementVNode("li", _hoisted_14, _toDisplayString(_ctx.$t(service.key[1])), 1),
              _createElementVNode("li", _hoisted_15, _toDisplayString(_ctx.$t(service.key[2])), 1),
              _createElementVNode("li", _hoisted_16, _toDisplayString(_ctx.$t(service.key[3])), 1),
              _createElementVNode("li", _hoisted_17, _toDisplayString(_ctx.$t(service.key[4])), 1)
            ])
          ]),
          _createElementVNode("button", {
            onClick: _cache[0] || (_cache[0] = ($event: any) => (goTocontactPage())),
            class: "bg-cyan-500 py-[5px] text-white rounded-[5px] w-full bottom-[10px]"
          }, _toDisplayString(_ctx.$t("contact_us")), 1)
        ])
      ])
    ]))
  }), 256))
}
}

})